const Button = ({
    type = [],
    callback = () => null,
    children
}) => {
    return (
        <span className={`button ${type.join(' ')}`} onClick={callback}>
            <div className="text">{children}</div>
        </span>
    )
}

export default Button